export const ComponentAddressInfo = () => {
    return (
        <>
            Zīlānu iela 66C, <br/>
            Jēkabpils, LV-5202 <br/>
            +371 25606007 <br/>
            info@patajekabpils.lv <br/>
        </>
    )
}